import React, { /*Component*/ useState, useEffect } from 'react';
import { getApplication, retrieveQuoteFromToken, startApplication, retrieveResourceFromToken} from '../api/applicationAPI';
import { navigateWithData, navigate } from '../navigation/navigationHistory';
import { env } from '../env';

export function RetrieveTokenQuote(props) {

    const { errorMsgToken, errorMsgPostalCode, pleaseWaitMsg } = props;
    const { token, postalCode, newQuote, editInd, carrierGroup: carrierGroupCd, licenseClass: licenseClassCd, effectiveDate } = env;  // The env structure captures all URL query parameters
    const [errorMessage, setErrorMessage] = useState();
    let { carrierGroupId, licenseClass} = props;
    const carrierGrp = carrierGroupCd ? carrierGroupCd : carrierGroupId;
    const licenseCls = licenseClassCd ? licenseClassCd : licenseClass;


    function isTrue(value) {
        const falses = [ 'no', 'false', 'off', '0' ];
        let result = false;

        if (value) {
            // If there is no value for the property, treat it as 'true'
            result = true;
            // If the property's value matches a 'no' word, treat it as 'false'
            if (falses.includes(value)) result = false;
        }

        return (result);
    }

    function handleQuoteFromToken(tokenParam) {
        const request = { clientId: 'ServicePortal', resourceToken: tokenParam };

        if (isTrue(newQuote)) {
            // Map the token to a system ID and redirect to edit application
            retrieveResourceFromToken(request).then((resourceDetail) => {
                if (resourceDetail.resource === 'customers') {
                  startApplication({carrierGroupId: carrierGrp, postalCode: postalCode, licenseClass: licenseCls, customerRef: resourceDetail.id, effectiveDate: effectiveDate}).then((systemId) => {
                    navigate(`/application/${systemId}`);
                  });
                } else {
                  return setErrorMessage(errorMsgToken);
                }
            })
            .catch((err2) => {
                console.log(`Cannot resolve token for ${token}: ${err2}`);
                return setErrorMessage(errorMsgToken);
            });
        } else {
            // Map the token to a system ID, read the quote data, and redirect to summary
            retrieveQuoteFromToken(request).then((systemId) => {
                delete env.token;  // this value is no longer needed
                if (isTrue(editInd)) {
                    navigate(`/application/${systemId}`);
                } else {
                    getApplication(systemId).then((app) => {
                        navigateWithData('/quote-summary', app);
                    })
                    .catch((err) => {
                        console.log(`Cannot retrieve quote for ${systemId}: ${err}`);
                        return setErrorMessage(errorMsgToken);
                    });
                }
            })
            .catch((err2) => {
                console.log(`Cannot resolve token for ${token}: ${err2}`);
                return setErrorMessage(errorMsgToken);
            });
        }

    }

    function handleQuoteForPostalCode(postalCode) {
        // Start a new application using the indicated zip code (if possible)
        startApplication({carrierGroupId: carrierGrp, postalCode: postalCode, licenseClass: licenseCls, effectiveDate: effectiveDate}).then((systemId) => {
            navigate(`/application/${systemId}`);
        })
        .catch((err) => {
            console.log(`Cannot start new application for ${postalCode}: ${err}`);
            return setErrorMessage(errorMsgPostalCode);
        });
    }

    if (token) {
        // Retrieve an already-created quote from the given token and navigate to it
        handleQuoteFromToken(token);
    } else {
        // Start a new quote using the postal-code that was given
        handleQuoteForPostalCode(postalCode);
    }

    return (
        <div>
            <p>{errorMessage ? errorMessage : pleaseWaitMsg}</p>
        </div>
    );
}
 
